var map = {
	"./avatar.jpg": 61920,
	"./background.jpg": 15035,
	"./favicon/android-chrome-192x192.png": 71311,
	"./favicon/android-chrome-256x256.png": 54863,
	"./favicon/apple-touch-icon.png": 20936,
	"./favicon/favicon-16x16.png": 11815,
	"./favicon/favicon-32x32.png": 87295,
	"./favicon/favicon.ico": 96864,
	"./favicon/mstile-150x150.png": 50355,
	"./favicon/safari-pinned-tab.svg": 86280,
	"./logo-inverse.png": 37573,
	"./logo-inverse.svg": 55706,
	"./logo.png": 94010,
	"./logo.svg": 65429,
	"./missing.png": 54815,
	"./singularbrain-inverse.png": 14785,
	"./singularbrain.png": 61022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86190;